export default __webpack_public_path__ + "static/media/departmentgovernance.f31404bb.png";